export default __webpack_public_path__ + "static/media/icon-notification-bell-v2.193e29ec.svg";